var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAiSummaryThumbsupFill = function SvgIcAiSummaryThumbsupFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16181C",
    d: "M3.425 4.8h-.8a1 1 0 0 0-1 1v6.864a1 1 0 0 0 1 1h.8a1 1 0 0 0 1-1V5.8a1 1 0 0 0-1-1M4.822 6.35v5.314a2 2 0 0 0 2 2h4.581a1.67 1.67 0 0 0 1.608-1.228l1.306-4.792a1.667 1.667 0 0 0-1.608-2.105h-2.73V3a1.333 1.333 0 0 0-1.333-1.333h-.024a1.33 1.33 0 0 0-1.114.6z"
  })));
};
export default SvgIcAiSummaryThumbsupFill;